/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Summary_Event_Group_TitleInputs */

const en_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group`)
};

const fr_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements`)
};

const de_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe`)
};

const it_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo eventi`)
};

const ru_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий`)
};

const es_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

const zh_cn2_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप`)
};

const pt_pt2_new_project_summary_event_group_title = /** @type {(inputs: New_Project_Summary_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {New_Project_Summary_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_summary_event_group_title = /** @type {((inputs?: New_Project_Summary_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Summary_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_summary_event_group_title(inputs)
	if (locale === "de") return de_new_project_summary_event_group_title(inputs)
	if (locale === "it") return it_new_project_summary_event_group_title(inputs)
	if (locale === "ru") return ru_new_project_summary_event_group_title(inputs)
	if (locale === "es") return es_new_project_summary_event_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_summary_event_group_title(inputs)
	if (locale === "ja") return ja_new_project_summary_event_group_title(inputs)
	if (locale === "hi") return hi_new_project_summary_event_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_summary_event_group_title(inputs)
	return en_new_project_summary_event_group_title(inputs)
});